module.exports = __webpack_public_path__ + "media/img/event/sponsor/htmi-logo-e44f5243cdd89b9b5fece94d32925e44.png";